import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArrowHeadBottom = props => (
  <SvgIcon {...props} viewBox="0 0 12 7.4099999">
    <path d="m10.59 0-4.59 4.58-4.59-4.58-1.41 1.41l6 6 6-6z" />
  </SvgIcon>
);

export default IconArrowHeadBottom;



// WEBPACK FOOTER //
// ./src/components/icons/IconArrowHeadBottom.js